import { resetWidget } from "@/CommonDP/VForm/utils";
export function resetDate() {
  resetWidget('date', (schema) => {
    schema.component = require('./index.vue').default;
    return schema;
  });
}
